import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// Thin top progress bar that gives instant feedback on every route change
// (covers both lazy-chunk fetches and per-page data loads).
export function NavProgress() {
  const loc = useLocation();
  const [phase, setPhase] = useState("idle"); // idle | start | done

  useEffect(() => {
    setPhase("start");
    const grow = setTimeout(() => setPhase("done"), 120);
    const hide = setTimeout(() => setPhase("idle"), 650);
    return () => {
      clearTimeout(grow);
      clearTimeout(hide);
    };
  }, [loc.pathname]);

  const width = phase === "start" ? "30%" : phase === "done" ? "100%" : "0%";
  const opacity = phase === "idle" ? 0 : 1;

  return (
    <div
      aria-hidden
      data-testid="nav-progress"
      className="pointer-events-none fixed left-0 top-0 z-[200] h-[3px] bg-gold shadow-[0_0_8px_rgba(212,175,55,0.6)]"
      style={{
        width,
        opacity,
        transition: "width 0.5s ease-out, opacity 0.35s ease-out",
      }}
    />
  );
}
